<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-10 16:56:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-19 11:45:38
 * @FilePath: /chaoyongtuan/src/views/teamManage/performanceManage/components/staffSelect/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEs
-->
<template>
	<div class="staff-list">
		<el-select filterable style="width: 100%" v-model="userId" clearable placeholder="请选择员工" @change="change">
			<el-option :label="item.name" :value="item.userId" v-for="item in userList" :key="item.userId">
				<div class="flex flex-align-center">
					<span class="mr-8">{{ item.name }}</span>
					<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
					<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
				</div>
			</el-option>
		</el-select>
	</div>
</template>
<script>
import { commonAllUser } from '@/api/teamManage';
export default {
	props: {
		value: {
			type: String,
			default: '',
		},
	},
	watch: {
		value(val) {
			this.userId = val;
		},
	},
	data() {
		return {
			userList: [],
			userId: this.value,
		};
	},
	methods: {
		async getList() {
			const { data, code } = await commonAllUser();
			if (code !== 0) return;
			this.userList = data;
		},
		change(val) {
			this.$emit('change', val);
			this.$emit('input', val);
		},
	},
	created() {
		this.getList();
	},
};
</script>
<style lang="less" scoped></style>
